'use client';

import { SettingsProvider } from '../contexts/SettingsContext';
import { AuthUIProvider } from "@daveyplate/better-auth-ui";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { authClient } from "../utils/auth-client";
import { Toaster } from "../components/ui/sonner";
import { PostHogProvider } from "../components/PostHogProvider";

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const router = useRouter();

  return (
    <PostHogProvider>
      <AuthUIProvider
        authClient={authClient}
        navigate={(url) => router.push(url)}
        replace={(url) => router.replace(url)}
        Link={Link as any}
        social={{
          providers: ["google", "apple"]
        }}
        passkey={false}
      >
        <SettingsProvider>
          {children}
          <Toaster />
        </SettingsProvider>
      </AuthUIProvider>
    </PostHogProvider>
  );
}
